module.exports = __webpack_public_path__ + "static/fonts/Montserrat-BoldItalic.1b38414.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Montserrat-BoldItalic.ttf
// module id = k6Pq
// module chunks = 1